export default () =>
  parseFloat(
    window
      .getComputedStyle(document.querySelector('html') as HTMLElement, null)
      .getPropertyValue('font-size'),
  );
